import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import type { ResponsiveColorsType } from '../Box';
import type { PriceSize } from '../Price';
import type { TypographyScales } from '../Typography';

import * as S from './Complimentary.styles';

export interface ComplimentaryProps {
  className?: string;
  color?: ResponsiveColorsType;
  scale?: TypographyScales;
  size?: PriceSize;
}

export const Complimentary: FC<ComplimentaryProps> = ({
  className,
  color = 'defaultAdd3',
  scale = 'p3',
  size = 'm',
}) => {
  return (
    <S.ComplimentaryText
      $size={size}
      className={className}
      color={color}
      data-testid='ComplimentaryText'
      scale={scale}
    >
      <FormattedMessage
        defaultMessage='Complimentary'
        id='checkout.reviewOrder.complimentary'
      />
    </S.ComplimentaryText>
  );
};
